module.exports = __webpack_public_path__ + "img/about-pic1.a104fe53.png";